// extracted by css-extract-rspack-plugin
export default {"cls1":"OnboardingTour-cls1_O5o","cls2":"OnboardingTour-cls2_WBM OnboardingTour-cls1_O5o"};